import { z } from 'zod'

/** 營業人員 - 共用欄位 Schema */
export const salesCommonSchema = z.object({
  /** 員工編號 */
  empNo: z.string(),
  /** 員工姓名 */
  name: z.string(),
  /** 員工姓名[英文] */
  englishName: z.string(),
  /** 單位代碼 */
  departmentCode: z.string(),
  /** 單位名稱 */
  departmentName: z.string()
})

/** 營業人員 - 共用欄位 Schema */
export interface SalesCommon extends z.infer<typeof salesCommonSchema> {}
